import React from "react";
import { Col, Card, CardBody, Spinner } from "reactstrap";
import { Link } from "react-router-dom";

//Simple bar
import SimpleBar from "simplebar-react";

//Import Images
import img1 from "../../assets/images/companies/img-1.png";
import img2 from "../../assets/images/companies/img-2.png";
import img3 from "../../assets/images/companies/img-3.png";
import { useQuery } from "react-query";
import { getAllSpaceNotifications, getNotifications } from "helpers/fakebackend_helper";
import UserAvatarFromName from "components/Common/UserAvatarFromName";

const Notifications = () => {

  const { data, isLoading } = useQuery('allnotifications', getAllSpaceNotifications, {
    staleTime: 120000,
      refetchOnWindowFocus: false,
    });

    const systemNotifications = [
      
    ];

    const notifications = data?.notifications?.length < 4 ? [...data?.notifications, ...systemNotifications] : data?.notifications;

  return (
    <React.Fragment>
      <Col  >
        <Card    style={{  height: '550px' }}>
          <CardBody>
            <h4 className="card-title mb-4">App Notifications</h4>
            {isLoading ? <div className="text-center"><Spinner /></div> : (
            <SimpleBar style={{ maxHeight: "420px" }}>
              <ul className="list-group">
                {notifications?.map((notification, index) => (
                <li className="list-group-item border-0" key={index}>
                  <div className="d-flex justify-content-between">
                    <div className="d-flex">
                      <div className="avatar-xs me-3">
                        <span className="avatar-title rounded-circle bg-light">
                         <UserAvatarFromName name={notification?.created_by?.name} size="sm" />
                        </span>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="font-size-14">{notification?.created_by?.name}</h5>
                        <p className="text-muted">
                          {notification?.notification_message}
                        </p>
                        <p className="text-muted mb-0">{new Date(notification?.created_at).toLocaleDateString([], { month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' })}</p>
                      </div>
                    </div>
                    <div>
                      <Link to={`/parenting-menu/${notification?.parenting_space?.id}`} className="text-primary">
                        Go to Space
                      </Link>
                    </div>
                  </div>
                </li>
                ))}
              </ul>
            </SimpleBar>
            )}
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default Notifications;
